// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/announce_media_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { AnnounceMedia } from "../../entity/announce_pb";

/**
 * UploadAnnounceMediaArgs メッセージ
 *
 * @generated from message service.UploadAnnounceMediaArgs
 */
export class UploadAnnounceMediaArgs extends Message<UploadAnnounceMediaArgs> {
  /**
   * @generated from field: bytes file_data = 1 [json_name = "file_data"];
   */
  fileData = new Uint8Array(0);

  /**
   * @generated from field: string file_name = 2 [json_name = "file_name"];
   */
  fileName = "";

  /**
   * @generated from field: string content_type = 3 [json_name = "content_type"];
   */
  contentType = "";

  /**
   * @generated from field: string announce_id = 4 [json_name = "announce_id"];
   */
  announceId = "";

  /**
   * @generated from field: string media_type = 5 [json_name = "media_type"];
   */
  mediaType = "";

  /**
   * @generated from field: string caption = 6;
   */
  caption = "";

  constructor(data?: PartialMessage<UploadAnnounceMediaArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UploadAnnounceMediaArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_data", jsonName: "file_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "file_name", jsonName: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_type", jsonName: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "announce_id", jsonName: "announce_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "media_type", jsonName: "media_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadAnnounceMediaArgs {
    return new UploadAnnounceMediaArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadAnnounceMediaArgs {
    return new UploadAnnounceMediaArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadAnnounceMediaArgs {
    return new UploadAnnounceMediaArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UploadAnnounceMediaArgs | PlainMessage<UploadAnnounceMediaArgs> | undefined, b: UploadAnnounceMediaArgs | PlainMessage<UploadAnnounceMediaArgs> | undefined): boolean {
    return proto3.util.equals(UploadAnnounceMediaArgs, a, b);
  }
}

/**
 * DeleteAnnounceMediaArgs メッセージ
 *
 * @generated from message service.DeleteAnnounceMediaArgs
 */
export class DeleteAnnounceMediaArgs extends Message<DeleteAnnounceMediaArgs> {
  /**
   * @generated from field: string storage_path = 1 [json_name = "storage_path"];
   */
  storagePath = "";

  constructor(data?: PartialMessage<DeleteAnnounceMediaArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteAnnounceMediaArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "storage_path", jsonName: "storage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAnnounceMediaArgs {
    return new DeleteAnnounceMediaArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAnnounceMediaArgs {
    return new DeleteAnnounceMediaArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAnnounceMediaArgs {
    return new DeleteAnnounceMediaArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAnnounceMediaArgs | PlainMessage<DeleteAnnounceMediaArgs> | undefined, b: DeleteAnnounceMediaArgs | PlainMessage<DeleteAnnounceMediaArgs> | undefined): boolean {
    return proto3.util.equals(DeleteAnnounceMediaArgs, a, b);
  }
}

/**
 * UploadAnnounceMediaReply メッセージ
 *
 * @generated from message service.UploadAnnounceMediaReply
 */
export class UploadAnnounceMediaReply extends Message<UploadAnnounceMediaReply> {
  /**
   * @generated from field: entity.AnnounceMedia media = 1;
   */
  media?: AnnounceMedia;

  constructor(data?: PartialMessage<UploadAnnounceMediaReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UploadAnnounceMediaReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "media", kind: "message", T: AnnounceMedia },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadAnnounceMediaReply {
    return new UploadAnnounceMediaReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadAnnounceMediaReply {
    return new UploadAnnounceMediaReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadAnnounceMediaReply {
    return new UploadAnnounceMediaReply().fromJsonString(jsonString, options);
  }

  static equals(a: UploadAnnounceMediaReply | PlainMessage<UploadAnnounceMediaReply> | undefined, b: UploadAnnounceMediaReply | PlainMessage<UploadAnnounceMediaReply> | undefined): boolean {
    return proto3.util.equals(UploadAnnounceMediaReply, a, b);
  }
}

/**
 * DeleteAnnounceMediaReply メッセージ
 *
 * @generated from message service.DeleteAnnounceMediaReply
 */
export class DeleteAnnounceMediaReply extends Message<DeleteAnnounceMediaReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<DeleteAnnounceMediaReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteAnnounceMediaReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAnnounceMediaReply {
    return new DeleteAnnounceMediaReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAnnounceMediaReply {
    return new DeleteAnnounceMediaReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAnnounceMediaReply {
    return new DeleteAnnounceMediaReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAnnounceMediaReply | PlainMessage<DeleteAnnounceMediaReply> | undefined, b: DeleteAnnounceMediaReply | PlainMessage<DeleteAnnounceMediaReply> | undefined): boolean {
    return proto3.util.equals(DeleteAnnounceMediaReply, a, b);
  }
}

